import { tourStep } from './tourRegistry';

export const bandaEnsayosSteps = [
  tourStep(
    'ensayos-header',
    'Ensayos',
    'Programa ensayos, pasa lista y asigna repertorio. Si aún no hay músicos, esta pantalla permanece bloqueada.',
  ),
  tourStep(
    'ensayos-vistas',
    'Lista, calendario y estadísticas',
    'Cambia de vista para ver próximos ensayos, el mes o el resumen de asistencia.',
  ),
  tourStep(
    'ensayos-sedes',
    'Sedes',
    'Lugares de ensayo. Crea al menos una sede (y márcala como predeterminada) antes del primer ensayo.',
  ),
  tourStep(
    'ensayos-nuevo',
    'Nuevo ensayo',
    'Fecha, sede, grupos de músicos convocados y repertorio. Luego puedes pasar lista o enviar la encuesta por WhatsApp.',
  ),
  tourStep(
    'ensayos-grupos',
    'Grupos de ensayos',
    'Filtra ensayos por grupo de ensayos o crea grupos de ensayos (distintos de los grupos de músicos de Mis músicos).',
  ),
  tourStep(
    'ensayos-vacaciones',
    'Vacaciones',
    'Marca periodos en los que no hay ensayo (Semana Santa, verano…). Aparecen en el calendario.',
    'top',
  ),
];
